// Separate routes keep the existing object cards and their nested tabs unchanged.
export const historyLinksRoutes = [
  { path: 'leads/:objectId/links', type: 'lead' },
  { path: 'company/:objectId/links', type: 'company' },
  { path: 'contracts/:objectId/links', type: 'contract' },
  { path: 'purchases/:objectId/links', type: 'purchase' },
  { path: 'invoice/:objectId/links', type: 'invoice' },
  { path: 'supplier-invoices/:objectId/links', type: 'invoice' },
  { path: 'client-invoices/:objectId/links', type: 'invoice' },
  { path: 'accounting/:objectId/links', type: 'payment' },
  { path: 'wcc/:objectId/links', type: 'wcc' },
  { path: 'events/:objectId/links', type: 'event' },
];

export const historyLinksObjectTypes = [
  'lead', 'company', 'contract', 'purchase', 'invoice', 'payment', 'wcc', 'event',
  'invoice-row', 'payment-row', 'contact', 'file',
];

export function getObjectLinksPath(type: string, id: number) {
  const route = historyLinksRoutes.find((item) => item.type === type);
  // Related records without a standalone card still have a directly addressable diagram.
  return route ? `/${route.path.replace(':objectId', String(id))}` : `/links/${type}/${id}`;
}
